import type {
  Reservation,
  ReservationHistoryAction,
  ReservationHistoryEntry,
  ReservationStatus,
} from "./hosTypes";

type AddReservationHistoryEntryInput = {
  reservationId: string;
  action: ReservationHistoryAction;
  oldStatus: ReservationStatus;
  newStatus: ReservationStatus;
  reason: string;
  actor?: string;
  note?: string;
  timestamp?: string;
  affectedRoomId?: string;
  affectedEventId?: string;
  fieldChanges?: Record<string, string>;
};

function createHistoryId() {
  return `hist-${Math.floor(1000 + Math.random() * 8999)}`;
}

export function addReservationHistoryEntry(
  entries: ReservationHistoryEntry[],
  input: AddReservationHistoryEntryInput
) {
  const entry: ReservationHistoryEntry = {
    id: createHistoryId(),
    reservationId: input.reservationId,
    timestamp: input.timestamp ?? new Date().toISOString(),
    action: input.action,
    oldStatus: input.oldStatus,
    newStatus: input.newStatus,
    reason: input.reason.trim(),
    actor: input.actor?.trim() || undefined,
    note: input.note,
    affectedRoomId: input.affectedRoomId,
    affectedEventId: input.affectedEventId,
    fieldChanges: input.fieldChanges,
  };

  return {
    entry,
    entries: [entry, ...entries],
  };
}

export function appendReservationHistoryEntries(
  entries: ReservationHistoryEntry[],
  additions: AddReservationHistoryEntryInput[]
) {
  return additions.reduce(
    (current, nextInput) => addReservationHistoryEntry(current, nextInput).entries,
    entries
  );
}

export function getReservationHistory(
  reservationId: string,
  entries: ReservationHistoryEntry[]
) {
  return entries.filter((entry) => entry.reservationId === reservationId);
}

export function buildCancelledReservation(
  reservation: Reservation,
  reason: string,
  actor?: string,
  timestamp?: string
): Reservation {
  const cancelledAt = timestamp ?? new Date().toISOString();
  return {
    ...reservation,
    status: "cancelled",
    cancellationReason: reason.trim(),
    cancelledAt,
    cancelledBy: actor?.trim() || undefined,
  };
}
